"use client";

import { plural } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";
import { Button } from "@offstreetparking/design-system/forms";
import { TimeIcon } from "@offstreetparking/design-system/icons/TimeIcon";
import { Text } from "@offstreetparking/design-system/typography";
import { useCallback, useEffect, useState } from "react";
import { routes } from "../../../../routes/routes";
import { useKiosk } from "../../../providers/KioskProvider";

const COUNTDOWN_SECONDS = 60;

export const KioskCountdown = () => {
	const { startOverLookupId } = useKiosk();

	if (!startOverLookupId) {
		return null;
	}

	return <Countdown startOverLookupId={startOverLookupId} />;
};

const Countdown = ({ startOverLookupId }: { startOverLookupId: string }) => {
	const { t } = useLingui();
	const [endTime] = useState(() => Date.now() + COUNTDOWN_SECONDS * 1000);
	const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS);

	const goBack = useCallback(() => {
		window.location.href = routes.locationLookup({ lookup: startOverLookupId });
	}, [startOverLookupId]);

	useEffect(() => {
		const tick = () => {
			const remaining = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
			setSecondsLeft(remaining);
			if (remaining <= 0) {
				goBack();
			}
		};
		const interval = window.setInterval(tick, 1000);
		return () => window.clearInterval(interval);
	}, [endTime, goBack]);

	return (
		<>
			<div aria-hidden className="h-30 print:hidden" />
			<div className="fixed right-0 bottom-0 left-0 z-topBar flex items-center justify-between gap-4 border-neutral-faded border-t bg-white px-6 py-4 print:hidden">
				<div className="flex items-center gap-2">
					<TimeIcon className="h-4 w-4" />
					<Text As="span" size="sm" aria-live="polite">
						{t`${plural(Math.max(secondsLeft, 0), {
							one: "Page will refresh automatically in # second",
							other: "Page will refresh automatically in # seconds",
						})}`}
					</Text>
				</div>

				<Button intent="primary" onClick={goBack}>
					{t`Done`}
				</Button>
			</div>
		</>
	);
};
